export default __webpack_public_path__ + "static/apple-touch-icon-2a96619bfdda5077a65a33c2a694b1d6.png";